import { Input } from "@/components/ui/input";

interface ValueInputProps {
  value: string | null;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const ValueInput = ({ value, onValueChange, disabled = false }: ValueInputProps) => (
  <Input
    className="w-full disabled:cursor-not-allowed disabled:bg-gray-50"
    value={value || ""}
    onChange={e => onValueChange(e.target.value)}
    disabled={disabled}
    placeholder="Enter the value to search for..."
  />
);

export default ValueInput;
